import React, { useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Card, Container, Row, Col, ListGroup } from "react-bootstrap";
import Map from "../../assets/images/location.svg";
import timer from "../../assets/svg/timer.svg";
import {
  getAverageDurationApi,
  getdockCountApi,
  getdockfreedocksApi,
  getdocklivemonitorApi,
  getdocklocationinoutApi,
  getDockStatusApi,
  getdocktimingsApi,
  getHistoryCountApi,
} from "./dock-api";
import LiveTimer from "./live-timer";
import { useGlobal } from "../../GlobalContext";
import rightArrow from "../../assets/svg/right-arrow.svg";

export default function DockDashboard({
  interval = 60,
  widgets = [
    /*  {
      id: null,
      name: "Dock status",
      widget_id: null,
      seq_no: 1,
      status: true,
    },
    {
      id: null,
      name: "Live count",
      widget_id: null,
      seq_no: 1,
      status: true,
    },
    {
      id: null,
      name: "History count",
      widget_id: null,
      seq_no: 1,
      status: true,
    },
    {
      id: null,
      name: "Location based dock in and out",
      widget_id: null,
      seq_no: 1,
      status: true,
    },
    {
      id: null,
      name: "Location based free docks",
      widget_id: null,
      seq_no: 1,
      status: true,
    },
    {
      id: null,
      name: "Average duration",
      widget_id: null,
      seq_no: 1,
      status: true,
    },
    {
      id: null,
      name: "Timings",
      widget_id: null,
      seq_no: 1,
      status: true,
    },
    {
      id: null,
      name: "Day wise gate and dock in",
      widget_id: null,
      seq_no: 1,
      status: true,
    },
    {
      id: null,
      name: "Day wise average duration",
      widget_id: null,
      seq_no: 1,
      status: true,
    },
    {
      id: null,
      name: "Vehicle came in and out",
      widget_id: null,
      seq_no: 1,
      status: true,
    },
    {
      id: null,
      name: "Department wise dock overview",
      widget_id: null,
      seq_no: 1,
      status: true,
    },
    {
      id: null,
      name: "Live monitor",
      widget_id: null,
      seq_no: 1,
      status: true,
    }, */
  ],
}) {
  let { dashboardToken } = useGlobal();
  if (process.env.REACT_APP_ENVIRONMENT === "development") {
    dashboardToken =
      "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2FwaS11YXQubWF3YWxvZy5jb20vc2lnbmFnZS92MS9hcGkvZGV2aWNlLzY3IiwiaWF0IjoxNzY3MTM5MTk5LCJleHAiOjE3OTg2NzUxOTksIm5iZiI6MTc2NzEzOTE5OSwianRpIjoiTGtBTU5qdHhCanFxNFBhRSIsInN1YiI6IjY3IiwicHJ2IjoiYjkwZjcxZjJiMDQ2ZjM1NDJhMDI3ODEwODllYTc1NjY4ZmUzYWU2MyIsImF1dGhpZCI6MTIzMiwib3JnaWQiOjEwNSwidXNlcmlkIjoxMjMyLCJkYXRhYmFzZW5hbWUiOiJyYWd1cnIiLCJvcmdfY29kZSI6InJhZ3VyciIsInRpbWV6b25lIjoiIiwicm9sZWlkIjo0OTcsInBheW1lbnRfc3RhdHVzIjp0cnVlLCJhdXRob3JpdGllcyI6WyJST0xFX1VTRVIiXSwiZGV2aWNlSWQiOjY3LCJncm91cElkIjo1Miwic2lnbmFnZV9jb2RlIjoiIn0.VpzQxFgAA2lqyRoIrKp9kkOiAg6j1-k7sfYQj9VO-4A";
  }
  const intervalRef = useRef(null);
  const statusTextStyle = (color) => ({
    color: color,
    fontWeight: "600",
    /* fontSize: "11px", */
  });

  const progressBar = (color) => ({
    position: "absolute",
    bottom: "0",
    right: "0",
    left: "0",
    height: "5px",
    borderRadius: "0 0 8px 8px",

    backgroundColor: color,
  });

  // add animation

  const scrollContainerStyle = {
    position: "relative",
    height: "70vh",
    overflow: "hidden",
    paddingLeft: "10px",
  };
  const scrollContainerStyleLiveMonitor = {
    position: "relative",
    height: "50vh",
    overflow: "hidden",
    paddingLeft: "10px",
  };
  const [dockcount, setdockcount] = useState({});
  const [dockHistoryCount, setDockHistoryCount] = useState({});
  const [timing, settiming] = useState([]);
  const [freedocks, setfreedocks] = useState([]);
  const [locationIn, setlocationIn] = useState([]);
  const [liveMonit, setliveMonit] = useState([]);
  const [dockStatusList, setDockStatusList] = useState([]);

  const locationDocksContentRef = useRef(null);
  const [locationDockDuration, setLocationDockDuration] = useState(10);
  const [sortedWidgetList, setSortedWidgetList] = useState([]);
  useEffect(() => {
    setSortedWidgetList([...widgets].sort((a, b) => a.seq_no - b.seq_no));
  }, []);
  useEffect(() => {
    if (locationDocksContentRef.current) {
      const height = locationDocksContentRef.current.scrollHeight;
      console.log("height....", height);
      // Customize speed: e.g., 50 pixels per second
      const pixelsPerSecond = 70;
      const calculatedDuration = height / pixelsPerSecond;
      console.log("calculatedDuration....", calculatedDuration);
      setLocationDockDuration(calculatedDuration);
    }
  }, [locationIn]);

  const scrollContentStyleFreeDocks = {
    display: "flex",
    flexDirection: "column",
    gap: "0px",
    animation: `scroll-vertical ${locationDockDuration}s linear infinite`,
  };

  const dockStatusContentRef = useRef(null);
  const [dockStatusDuration, setDockStatusDuration] = useState(10);
  useEffect(() => {
    if (dockStatusContentRef.current) {
      const height = dockStatusContentRef.current.scrollHeight;
      console.log("height....", height);
      // Customize speed: e.g., 50 pixels per second
      const pixelsPerSecond = 70;
      const calculatedDuration = height / pixelsPerSecond;
      console.log("calculatedDuration....", calculatedDuration);
      setDockStatusDuration(calculatedDuration);
    }
  }, [dockStatusList]);

  const scrollContentStyleDockStatus = {
    display: "flex",
    flexDirection: "column",
    gap: "0px",
    animation: `scroll-vertical ${dockStatusDuration}s linear infinite`,
  };

  const vehicleTimingContentRef = useRef(null);
  const [vehicleTimingDuration, setVehicleTimingDuration] = useState(30);
  useEffect(() => {
    if (vehicleTimingContentRef.current) {
      const height = vehicleTimingContentRef.current.scrollWidth;
      console.log("height.time...", height);
      // Customize speed: e.g., 50 pixels per second
      const pixelsPerSecond = 200;
      const calculatedDuration = height / pixelsPerSecond;
      console.log("calculatedDuration...time.", calculatedDuration);
      setVehicleTimingDuration(calculatedDuration);
    }
  }, [timing]);

  const scrollContainerTimeStyle = {
    overflow: "hidden",
    padding: "10px",
    backgroundColor: "#FFFFFF",
    borderRadius: "8px",
    position: "relative",
    width: "100%",
    /* height: 'auto' */
  };

  const scrollContentStyleTiming = {
    display: "grid",
    gridAutoFlow: "column",
    /* gridTemplateRows: '1fr 1fr', */
    gap: "12px",
    animation: `scroll-horizontal ${vehicleTimingDuration}s linear infinite`,
    minWidth: "max-content",
  };

  const liveMonitorContentRef = useRef(null);
  const [liveMonitorDuration, setLiveMonitorDuration] = useState(10);
  useEffect(() => {
    if (liveMonitorContentRef.current) {
      const height = liveMonitorContentRef.current.scrollHeight;
      console.log("height.time...", height);
      // Customize speed: e.g., 50 pixels per second
      const pixelsPerSecond = 70;
      const calculatedDuration = height / pixelsPerSecond;
      console.log("calculatedDuration...time.", calculatedDuration);
      setLiveMonitorDuration(calculatedDuration);
    }
  }, [liveMonit]);
  const scrollContentStyleLiveMonitor = {
    height: "max-content",
    display: "flex",
    flexWrap: "wrap",
    gap: "10px",
    overflow: "hidden",
    animation: `scroll-vertical ${liveMonitorDuration}s linear infinite`,
  };

  useEffect(() => {
    const styleId = "vertical-scroll-keyframes";
    if (!document.getElementById(styleId)) {
      const style = document.createElement("style");
      style.id = styleId;
      style.innerHTML = `
                @keyframes scroll-vertical {
                    0% { transform: translateY(0); }
                    100% { transform: translateY(-50%); }
                }
            `;
      document.head.appendChild(style);
    }
  }, []);
  useEffect(() => {
    const styleId = "horizontal-scroll-keyframes";
    if (!document.getElementById(styleId)) {
      const style = document.createElement("style");
      style.id = styleId;
      style.innerHTML = `
           @keyframes scroll-horizontal {
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); } /* Adjust based on duplication */
}

            `;
      document.head.appendChild(style);
    }
  }, []);

  const callAllAPIs = () => {
    sortedWidgetList.forEach((widget) => {
      if (widget.status && apiMap[widget.name]) {
        apiMap[widget.name]();
      }
    });
  };
  useEffect(() => {
    // Initial API call
    callAllAPIs();

    // Setup interval
    intervalRef.current = setInterval(() => {
      callAllAPIs();
    }, interval * 1000); // convert seconds to ms

    // Cleanup on unmount
    return () => clearInterval(intervalRef.current);
  }, [interval, sortedWidgetList]);

  const getCountDetails = async () => {
    const response = await getdockCountApi(dashboardToken);
    console.log("response....");

    if (response?.data?.success === true) {
      setdockcount(response.data.count.warehouseDocks ?? {});
    }
  };

  const getHistoryCount = async () => {
    try {
      const response = await getHistoryCountApi(dashboardToken);
      if (response?.data?.success === true) {
        setDockHistoryCount(response.data.count);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getTimingsDetails = async () => {
    const response = await getdocktimingsApi(dashboardToken);
    console.log("response....");

    if (response?.data?.success === true) {
      settiming(response.data.timings ?? []);
    }
  };
  const getdockfreeDetails = async () => {
    const response = await getdockfreedocksApi(dashboardToken);
    console.log("response....");

    if (response?.data?.success === true) {
      setfreedocks(response.data.freedocks ?? []);
    }
  };
  function getStatusLabel(status) {
    const statusMap = {
      ontime: "On Time",
      overdelay: "Over Delay",
      delay: "Delay",
    };

    return statusMap[status?.toLowerCase()] ?? status;
  }

  const getlocationinoutDetails = async () => {
    const response = await getdocklocationinoutApi(dashboardToken);
    console.log("response....");

    if (response?.data?.success === true) {
      setlocationIn(response.data.locatinBasedInAndOut ?? []);
    }
  };
  const getLiveMonitorDetails = async () => {
    const response = await getdocklivemonitorApi(dashboardToken);
    console.log("response....");

    if (response?.data?.success === true) {
      setliveMonit(response.data.liveDocks ?? []);
    }
  };

  const [averageData, setAverageData] = useState(null);
  const fetchAverageData = async () => {
    try {
      const response = await getAverageDurationApi(
        { period: "" },
        dashboardToken
      );
      if (response?.data?.success) {
        setAverageData(response.data.average);
      } else {
      }
    } catch (err) {
    } finally {
    }
  };

  const fetchDockStatusData = async () => {
    try {
      const response = await getDockStatusApi(dashboardToken);
      if (response?.data?.success) {
        setDockStatusList(response.data.docks);
      } else {
      }
    } catch (err) {
    } finally {
    }
  };
  const liveCountWidget = () => {
    const index = widgets.findIndex(
      (widget) => widget.name === "Live count" && widget.status === true
    );
    var fontPercentage = 0;
    if (index > -1) {
      fontPercentage = customFontPercentage(
        widgets[index].width,
        widgets[index].width_size
      );
    }
    return (
      widgets.some(
        (widget) => widget.name === "Live count" && widget.status === true
      ) && (
        <Col
          xs={12}
          sm={
            widgets.some(
              (widget) =>
                widget.name === "History count" && widget.status === false
            )
              ? 12
              : 6
          }
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: "5px",
              flex: "0 0 auto",
              paddingLeft: "20px",
            }}
          >
            <div
              style={{
                fontSize: `${fontResize(16, fontPercentage)}px`,
                fontWeight: 700,
                color: "#0D283E",
                letterSpacing: "1px",
              }}
            >
              Live
            </div>
          </div>
          <Row className="g-0 text-center pb-2">
            <Col
              xs={6}
              sm={4}
              md={2}
              lg={2}
              xl={true}
              style={{
                padding: "0px 0",
                borderRight: "1px solid #D5DDE7",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  fontSize: `${fontResize(30, fontPercentage)}px`,
                  fontWeight: 400,
                  color: "#0D283E",
                }}
              >
                {dockcount.gateIncount ?? 0}
              </div>
              <div
                style={{
                  fontSize: `${fontResize(12, fontPercentage)}px`,
                  fontWeight: 700,
                  color: "#707D88",
                }}
              >
                Gate in
              </div>
            </Col>
            <Col
              xs={6}
              sm={4}
              md={2}
              lg={2}
              xl={true}
              style={{
                padding: "0px 0",
                borderRight: "1px solid #D5DDE7",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  fontSize: `${fontResize(30, fontPercentage)}px`,
                  fontWeight: 400,
                  color: "#0D283E",
                }}
              >
                {dockcount.inQueue ?? 0}
              </div>
              <div
                style={{
                  fontSize: `${fontResize(12, fontPercentage)}px`,
                  fontWeight: 700,
                  color: "#707D88",
                }}
              >
                In queue
              </div>
            </Col>
            <Col
              xs={6}
              sm={4}
              md={2}
              lg={2}
              xl={true}
              style={{
                padding: "0px 0",
                borderRight: "1px solid #D5DDE7",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  fontSize: `${fontResize(30, fontPercentage)}px`,
                  fontWeight: 400,
                  color: "#0D283E",
                }}
              >
                {dockcount.dockIncount ?? 0}
              </div>
              <div
                style={{
                  fontSize: `${fontResize(12, fontPercentage)}px`,
                  fontWeight: 700,
                  color: "#707D88",
                }}
              >
                Dock in
              </div>
            </Col>

            <Col
              xs={6}
              sm={4}
              md={2}
              lg={2}
              xl={true}
              style={{
                padding: "0px 0",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  fontSize: `${fontResize(30, fontPercentage)}px`,
                  fontWeight: 400,
                  color: "#0D283E",
                }}
              >
                {dockcount.out_queue_count ?? 0}
              </div>
              <div
                style={{
                  fontSize: `${fontResize(12, fontPercentage)}px`,
                  fontWeight: 700,
                  color: "#707D88",
                }}
              >
                Out queue
              </div>
            </Col>
          </Row>
        </Col>
      )
    );
  };

  const historyCountWidget = () => {
    const index = widgets.findIndex(
      (widget) => widget.name === "History count" && widget.status === true
    );
    var fontPercentage = 0;
    if (index > -1) {
      fontPercentage = customFontPercentage(
        widgets[index].width,
        widgets[index].width_size
      );
    }
    return (
      widgets.some(
        (widget) => widget.name === "History count" && widget.status === true
      ) && (
        <Col
          xs={12}
          sm={
            widgets.some(
              (widget) =>
                widget.name === "Live count" && widget.status === false
            )
              ? 12
              : 6
          }
          style={{ borderLeft: "1px solid #D5DDE7" }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: "5px",
              flex: "0 0 auto",
              paddingLeft: "20px",
            }}
          >
            <div
              style={{
                fontSize: `${fontResize(16, fontPercentage)}px`,
                fontWeight: 700,
                color: "#0D283E",
                letterSpacing: "1px",
              }}
            >
              History
            </div>
          </div>
          <Row className="g-0 text-center pb-2">
            <Col
              xs={6}
              sm={4}
              md={2}
              lg={2}
              xl={true}
              style={{
                padding: "0px 0",
                borderRight: "1px solid #D5DDE7",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  fontSize: `${fontResize(30, fontPercentage)}px`,
                  fontWeight: 400,
                  color: "#0D283E",
                }}
              >
                {dockHistoryCount.gate_in ?? 0}
              </div>
              <div
                style={{
                  fontSize: `${fontResize(12, fontPercentage)}px`,
                  fontWeight: 700,
                  color: "#707D88",
                }}
              >
                Gate in
              </div>
            </Col>

            <Col
              xs={6}
              sm={4}
              md={2}
              lg={2}
              xl={true}
              style={{
                padding: "0px 0",
                borderRight: "1px solid #D5DDE7",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  fontSize: `${fontResize(30, fontPercentage)}px`,
                  fontWeight: 400,
                  color: "#0D283E",
                }}
              >
                {dockHistoryCount.dock_in ?? 0}
              </div>
              <div
                style={{
                  fontSize: `${fontResize(12, fontPercentage)}px`,
                  fontWeight: 700,
                  color: "#707D88",
                }}
              >
                Dock in
              </div>
            </Col>
            <Col
              xs={6}
              sm={4}
              md={2}
              lg={2}
              xl={true}
              style={{
                padding: "0px 0",
                borderRight: "1px solid #D5DDE7",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  fontSize: `${fontResize(30, fontPercentage)}px`,
                  fontWeight: 400,
                  color: "#0D283E",
                }}
              >
                {dockHistoryCount.dock_out ?? 0}
              </div>
              <div
                style={{
                  fontSize: `${fontResize(12, fontPercentage)}px`,
                  fontWeight: 700,
                  color: "#707D88",
                }}
              >
                Dock out
              </div>
            </Col>

            <Col
              xs={6}
              sm={4}
              md={2}
              lg={2}
              xl={true}
              style={{
                padding: "0px 0",
                borderRight: "1px solid #D5DDE7",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  fontSize: `${fontResize(30, fontPercentage)}px`,
                  fontWeight: 400,
                  color: "#0D283E",
                }}
              >
                {dockHistoryCount.gate_out ?? 0}
              </div>
              <div
                style={{
                  fontSize: `${fontResize(12, fontPercentage)}px`,
                  fontWeight: 700,
                  color: "#707D88",
                }}
              >
                Gate out
              </div>
            </Col>
            <Col
              xs={6}
              sm={4}
              md={2}
              lg={2}
              xl={true}
              style={{
                padding: "0px 0",
                borderRight: "1px solid #D5DDE7",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  fontSize: `${fontResize(30, fontPercentage)}px`,
                  fontWeight: 400,
                  color: "#0D283E",
                }}
              >
                {dockHistoryCount.not_handled ?? 0}
              </div>
              <div
                style={{
                  fontSize: `${fontResize(12, fontPercentage)}px`,
                  fontWeight: 700,
                  color: "#707D88",
                }}
              >
                Not Handled
              </div>
            </Col>
          </Row>
        </Col>
      )
    );
  };
  {
    /* LEFT COLUMN */
  }
  const locationBasedDockWidget = () => {
    const index = widgets.findIndex(
      (widget) =>
        widget.name === "Location based dock in and out" &&
        widget.status === true
    );
    var fontPercentage = 0;
    if (index > -1) {
      fontPercentage = customFontPercentage(
        widgets[index].width,
        widgets[index].width_size
      );
    }
    //Location based dock in and out
    return (
      widgets.some(
        (widget) =>
          widget.name === "Location based dock in and out" &&
          widget.status === true
      ) && (
        <Col style={{ flex: "0 1 260px", padding: 0 }}>
          <Container
            style={{
              backgroundColor: "#FFFFFF",
              padding: "10px 10px 10px 20px",
              maxWidth: "260px",
              borderRight: "1px solid #D5DDE7",
            }}
          >
            <div
              style={{
                color: "#0D283E",
                marginBottom: "10px",
                fontSize: `${fontResize(13, fontPercentage)}px`,
                fontWeight: 700,
                alignItems: "center",
                paddingLeft: "10px",
              }}
            >
              Location based Dock in & out
            </div>
            <div style={scrollContainerStyle}>
              <div
                style={scrollContentStyleFreeDocks}
                ref={locationDocksContentRef}
              >
                {[...locationIn].map((location, index) => (
                  <Card
                    key={`scroll-${index}`}
                    style={{
                      backgroundColor: "#EDF0F4",
                      color: "#0D283E",
                      marginBottom: "10px",
                      borderRadius: "12px",
                      padding: "20px 20px 20px 20px",
                      border: "none",
                    }}
                  >
                    <div
                      style={{
                        marginBottom: "2px",
                        fontSize: `${fontResize(12, fontPercentage)}px`,
                        fontWeight: "700",
                      }}
                    >
                      {location.location}
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <small
                        style={{
                          color: "#707D88",
                          fontSize: `${fontResize(11, fontPercentage)}px`,
                          fontWeight: "700",
                        }}
                      >
                        {location.month}
                      </small>
                      <div
                        className="px-2 d-flex justify-content-between align-items-center"
                        style={{
                          borderRadius: "100px",
                          background: "#DBE0E5",
                          /* height: "28px", */
                        }}
                      >
                        <span
                          style={{
                            fontSize: `${fontResize(12, fontPercentage)}px`,
                            fontWeight: "700",
                            color: "#0D283E",
                          }}
                        >
                          {location.dock_count ?? "0"} Docks
                        </span>
                      </div>
                    </div>
                    <div
                      style={{
                        borderTop: "1px solid #D5DDE7",
                        margin: "10px 0",
                      }}
                    ></div>

                    <Row style={{ alignItems: "center", marginBottom: "8px" }}>
                      <Col
                        xs={8}
                        style={{
                          fontSize: `${fontResize(12, fontPercentage)}px`,
                          fontWeight: "700",
                          justifyContent: "center",
                        }}
                      >
                        <span
                          style={{
                            height: "12px",
                            width: "12px",
                            borderRadius: "3px",
                            display: "inline-block",
                            marginRight: "8px",
                            backgroundColor: "#2D67F9",
                          }}
                        ></span>
                        Dock in
                      </Col>
                      <Col
                        xs={4}
                        style={{
                          textAlign: "right",
                          fontSize: `${fontResize(13, fontPercentage)}px`,
                          fontWeight: "700",
                        }}
                      >
                        {location.inCount}
                      </Col>
                    </Row>

                    <Row style={{ alignItems: "center" }}>
                      <Col
                        xs={8}
                        style={{
                          fontSize: `${fontResize(12, fontPercentage)}px`,
                          fontWeight: "700",
                          justifyContent: "center",
                        }}
                      >
                        <span
                          style={{
                            height: "12px",
                            width: "12px",
                            borderRadius: "3px",
                            display: "inline-block",
                            marginRight: "8px",
                            backgroundColor: "#A6C3FF",
                          }}
                        ></span>
                        Dock out
                      </Col>
                      <Col
                        xs={4}
                        style={{
                          textAlign: "right",
                          fontSize: `${fontResize(13, fontPercentage)}px`,
                          fontWeight: "700",
                        }}
                      >
                        {location.outCount}
                      </Col>
                    </Row>
                  </Card>
                ))}
              </div>
            </div>
          </Container>
        </Col>
      )
    );
  };

  {
    /* RIGHT COLUMN */
  }
  const dockStatusWidget = () => {
    const index = widgets.findIndex(
      (widget) => widget.name === "Dock status" && widget.status === true
    );
    var fontPercentage = 0;
    if (index > -1) {
      fontPercentage = customFontPercentage(
        widgets[index].width,
        widgets[index].width_size
      );
    }

    //"Dock status"
    return (
      widgets.some(
        (widget) => widget.name === "Dock status" && widget.status === true
      ) && (
        <Col style={{ flex: "0 1 260px", padding: 0 }}>
          <Container
            style={{
              backgroundColor: "#FFFFFF",
              height: "max-content",
              padding: "10px 20px 10px 6px",
              maxWidth: "260px",
              borderLeft: "1px solid #D5DDE7",
            }}
          >
            <div
              style={{
                color: "#0D283E",
                marginBottom: "10px",
                fontSize: `${fontResize(13, fontPercentage)}px`,
                fontWeight: 700,
                alignItems: "center",
                paddingLeft: "10px",
              }}
            >
              Dock Status{" "}
            </div>
            <div style={scrollContainerStyle}>
              <div
                style={scrollContentStyleDockStatus}
                ref={dockStatusContentRef}
              >
                {[...dockStatusList].map((dock, idx) => (
                  <div
                    className="mb-2"
                    style={{
                      borderRadius: "16px",
                      background:
                        dock.available_status === false ? "#FFEBEB" : "#E5FFF3",
                      padding: "12px",
                    }}
                  >
                    <div
                      style={{
                        fontSize: `${fontResize(14, fontPercentage)}px`,
                        fontWeight: "700",
                        color: "#0D283E",
                      }}
                    >
                      {dock.dock}
                    </div>
                    <div className="mt-1 d-flex align-items-center gap-2">
                      <img
                        src={Map}
                        alt="location"
                        style={{
                          width: "14px",
                          height: "16px",
                          display: "inline-block",
                          verticalAlign: "middle",
                          objectFit: "contain",
                        }}
                      />
                      <span
                        style={{
                          fontSize: `${fontResize(12, fontPercentage)}px`,
                          color: "#0D283E",
                          fontWeight: "400",
                          // maxWidth: '140px', // or adjust based on layout
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          display: "inline-block",
                          verticalAlign: "middle",
                        }}
                        title={dock.location}
                      >
                        {dock.location}
                      </span>
                    </div>
                    <div
                      className="mt-1 d-flex justify-content-center align-items-center"
                      style={{
                        height: "29px",
                        borderRadius: "100px",
                        background: "#FFFFFF",
                      }}
                    >
                      <div
                        style={{
                          width: "8px",
                          height: "8px",
                          borderRadius: "100px",
                          background:
                            dock.available_status === false
                              ? "#FF4444"
                              : "#00B15C",
                        }}
                      ></div>
                      <div
                        className="ms-2"
                        style={{
                          fontSize: `${fontResize(13, fontPercentage)}px`,
                          fontWeight: "500",
                          color:
                            dock.available_status === false
                              ? "#FF4444"
                              : "#00B15C",
                        }}
                      >
                        {" "}
                        {dock.available_status === false
                          ? "Occupied"
                          : "Available"}{" "}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Container>
        </Col>
      )
    );
  };
  const timingWidget = () => {
    const index = widgets.findIndex(
      (widget) => widget.name === "Dock status" && widget.status === true
    );
    var fontPercentage = 0;
    if (index > -1) {
      fontPercentage = customFontPercentage(
        widgets[index].width,
        widgets[index].width_size
      );
    }
    return (
      <div>
        <div
          style={{
            color: "#0D283E",
            padding: "10px 10px 10px 0px",
            fontSize: `${fontResize(13, fontPercentage)}px`,
            fontWeight: 700,
            alignItems: "center",
          }}
        >
          Timings
        </div>

        <div style={scrollContainerTimeStyle}>
          <div style={scrollContentStyleTiming} ref={vehicleTimingContentRef}>
            {[...timing].map((item, index) => (
              <div
                key={index}
                style={{
                  /*  width: "180px", */
                  backgroundColor: "#EDF0F4",
                  padding: "8px 12px",
                  borderRadius: "12px",
                  boxSizing: "border-box",
                }}
              >
                <div
                  style={{
                    fontSize: `${fontResize(12, fontPercentage)}px`,
                    fontWeight: "400",
                    marginBottom: "4px",
                    color: "#0D283ECC",
                  }}
                >
                  {item.name}
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <img
                    src={timer}
                    alt="location"
                    style={{
                      width: "14px",
                      height: "14px",
                      display: "inline-block",
                      verticalAlign: "middle",
                      objectFit: "contain",
                    }}
                  />
                  {item.time}
                  <span
                    style={{
                      fontSize: `${fontResize(13, fontPercentage)}px`,
                      fontWeight: "700",
                      color: "#0D283E",
                    }}
                  >
                    {item.loadintime}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  const averageDurationWidget = (fontPercentage) => {
    return (
      <div>
        <div
          style={{
            color: "#0D283E",
            padding: "10px 10px 10px 0px",
            fontSize: `${fontResize(13, fontPercentage)}px`,
            fontWeight: 700,
            alignItems: "center",
          }}
        >
          Average duration
        </div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
          <div
            style={{
              flex: 1,
              /*  height: "88px", */
              borderRadius: "16px",
              padding: "12px",
              background: "#FFFFFF",
            }}
          >
            <div className="d-flex justify-content-start align-items-center">
              <span
                style={{
                  fontSize: `${fontResize(13, fontPercentage)}px`,
                  fontWeight: "600",
                  color: "#D35258",
                }}
                className="pe-2"
              >
                Gate in
              </span>
              <img
                src={rightArrow}
                alt="arrow"
                style={{ width: "14px", height: "14px" }}
              />
              <span
                className="ps-2"
                style={{
                  fontSize: `${fontResize(13, fontPercentage)}px`,
                  fontWeight: "600",
                  color: "#D35258",
                }}
              >
                Gate out
              </span>
            </div>
            <div className="mt-3 d-flex justify-content-start align-items-end">
              <span
                style={{
                  fontSize: `${fontResize(20, fontPercentage)}px`,
                  fontWeight: "700",
                  color: "#172B4D",
                }}
              >
                {averageData?.gatein_out ?? "0"}
              </span>{" "}
              <span
                style={{
                  paddingLeft: "6px",
                  fontSize: `${fontResize(14, fontPercentage)}px`,
                  fontWeight: "500",
                  color: "#172B4D",
                }}
              >
                mins
              </span>
            </div>
          </div>
          <div
            style={{
              flex: 1,
              /* height: "88px", */
              borderRadius: "16px",
              padding: "12px",
              background: "#FFFFFF",
            }}
          >
            <div className="d-flex justify-content-start align-items-center">
              <span
                style={{
                  fontSize: `${fontResize(13, fontPercentage)}px`,
                  fontWeight: "600",
                  color: "#D35258",
                }}
                className="pe-2"
              >
                Gate in
              </span>
              <img
                src={rightArrow}
                alt="arrow"
                style={{ width: "14px", height: "14px" }}
              />
              <span
                className="ps-2"
                style={{
                  fontSize: `${fontResize(13, fontPercentage)}px`,
                  fontWeight: "600",
                  color: "#D35258",
                }}
              >
                Dock in
              </span>
            </div>
            <div className="mt-3 d-flex justify-content-start align-items-end">
              <span
                style={{
                  fontSize: `${fontResize(20, fontPercentage)}px`,
                  fontWeight: "700",
                  color: "#172B4D",
                }}
              >
                {averageData?.gatein_dockin ?? "0"}
              </span>{" "}
              <span
                style={{
                  paddingLeft: "6px",
                  fontSize: `${fontResize(14, fontPercentage)}px`,
                  fontWeight: "500",
                  color: "#172B4D",
                }}
              >
                mins
              </span>
            </div>
          </div>
          <div
            style={{
              flex: 1,
              /* height: "88px", */
              borderRadius: "16px",
              padding: "12px",
              background: "#FFFFFF",
            }}
          >
            <div className="d-flex justify-content-start align-items-center">
              <span
                style={{
                  fontSize: `${fontResize(13, fontPercentage)}px`,
                  fontWeight: "600",
                  color: "#D35258",
                }}
                className="pe-2"
              >
                Dock in
              </span>
              <img
                src={rightArrow}
                alt="arrow"
                style={{ width: "14px", height: "14px" }}
              />
              <span
                className="ps-2"
                style={{
                  fontSize: `${fontResize(13, fontPercentage)}px`,
                  fontWeight: "600",
                  color: "#D35258",
                }}
              >
                Dock out
              </span>
            </div>
            <div className="mt-3 d-flex justify-content-start align-items-end">
              <span
                style={{
                  fontSize: `${fontResize(20, fontPercentage)}px`,
                  fontWeight: "700",
                  color: "#172B4D",
                }}
              >
                {averageData?.dockin_out ?? "0"}
              </span>{" "}
              <span
                style={{
                  paddingLeft: "6px",
                  fontSize: `${fontResize(14, fontPercentage)}px`,
                  fontWeight: "500",
                  color: "#172B4D",
                }}
              >
                mins
              </span>
            </div>
          </div>

          <div
            style={{
              flex: 1,
              /* height: "88px", */
              borderRadius: "16px",
              padding: "12px",
              background: "#FFFFFF",
            }}
          >
            <div className="d-flex justify-content-start align-items-center">
              <span
                style={{
                  fontSize: `${fontResize(13, fontPercentage)}px`,
                  fontWeight: "600",
                  color: "#D35258",
                }}
                className="pe-2"
              >
                Dock out
              </span>
              <img
                src={rightArrow}
                alt="arrow"
                style={{ width: "14px", height: "14px" }}
              />
              <span
                className="ps-2"
                style={{
                  fontSize: `${fontResize(13, fontPercentage)}px`,
                  fontWeight: "600",
                  color: "#D35258",
                }}
              >
                Gate out
              </span>
            </div>
            <div className="mt-3 d-flex justify-content-start align-items-end">
              <span
                style={{
                  fontSize: `${fontResize(20, fontPercentage)}px`,
                  fontWeight: "700",
                  color: "#172B4D",
                }}
              >
                {averageData?.dockout_gateout ?? "0"}
              </span>{" "}
              <span
                style={{
                  paddingLeft: "6px",
                  fontSize: `${fontResize(14, fontPercentage)}px`,
                  fontWeight: "500",
                  color: "#172B4D",
                }}
              >
                mins
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const liveMonitorWidget = (fontPercentage) => {
    return (
      <div>
        <div
          style={{
            color: "#0D283E",
            padding: "10px 10px 10px 0px",
            fontSize: `${fontResize(14, fontPercentage)}px`,
            fontWeight: 700,
            alignItems: "center",
          }}
        >
          Live Monitor
        </div>
        <div style={scrollContainerStyleLiveMonitor}>
          <div
            style={scrollContentStyleLiveMonitor}
            ref={liveMonitorContentRef}
          >
            {[...liveMonit].map((item, index) => (
              <div
                key={index}
                style={{
                  position: "relative",
                  flex: "1 1 220px",
                  backgroundColor: "#FFFFFF",
                  borderRadius: "8px",
                  padding: "10px",
                  boxShadow: "0px 2px 11px 0px rgba(0, 0, 0, 0.06)",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  minWidth: "clamp(230px, 30vw, 600px)",
                }}
              >
                <div>
                  {/* <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px',  }}>
                                                <div> */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "start",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: "700",
                        fontSize: `${fontResize(14, fontPercentage)}px`,
                        color: "#0D283E",
                      }}
                    >
                      {item.vehicle_number ?? ""}
                    </div>
                    <div
                      className="mx-1"
                      style={{
                        width: "6px",
                        height: "6px",
                        borderRadius: "100px",
                        background: "#DBE0E5",
                      }}
                    ></div>
                    <div
                      style={{
                        fontSize: `${fontResize(10, fontPercentage)}px`,
                        color: "#707D88",
                        fontWeight: "600",
                      }}
                    >
                      {item.dock_type === "load_in" ? "Loading" : ""}
                      {item.dock_type === "load_out" ? "Unloading" : ""}
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: "8px",
                    }}
                  >
                    <div>
                      <span
                        style={{
                          fontSize: `${fontResize(12, fontPercentage)}px`,
                          fontWeight: "400",
                          color: "#0D283E",
                        }}
                      >
                        Gate in :
                      </span>{" "}
                      <span
                        style={{
                          fontSize: `${fontResize(13, fontPercentage)}px`,
                          fontWeight: "700",
                          color: "#2D67F9",
                        }}
                      >
                        {item.gate_in_time ?? ""}
                      </span>{" "}
                    </div>
                    <div
                      className="px-2"
                      style={{
                        /*  height: "24px", */
                        fontSize: `${fontResize(11, fontPercentage)}px`,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "56px",
                        background:
                          item.current_status === "overdelay"
                            ? "#FFE8EC"
                            : item.current_status === "ontime"
                            ? "#D7FFEE"
                            : "#FFF7E2",
                      }}
                    >
                      <div
                        style={statusTextStyle(
                          item.current_status === "overdelay"
                            ? "#FF3B5F"
                            : item.current_status === "ontime"
                            ? "#40F7BE"
                            : "#FFC01B"
                        )}
                      >
                        {getStatusLabel(item.current_status)}
                      </div>
                    </div>
                    {/* </div>
                                                </div> */}
                  </div>
                  <div style={{ height: "1px", background: "#EBEBEB" }}></div>
                  <div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: "8px",
                        marginBottom: "8px",
                      }}
                    >
                      <div>
                        <div
                          style={{
                            fontSize: `${fontResize(11, fontPercentage)}px`,
                            color: "#707D88",
                            fontWeight: "600",
                          }}
                        >
                          Dock in Time
                        </div>
                        <div
                          style={{
                            display: "flex",
                            fontSize: `${fontResize(13, fontPercentage)}px`,
                            alignItems: "center",
                            justifyContent: "center",
                            fontWeight: "600",
                            color: "#0D283E",
                            height: "100%",
                            minHeight: "20px",
                          }}
                        >
                          <span
                            style={{
                              marginRight: "5px",
                              color: "#0D283E",
                            }}
                          >
                            ⏱
                          </span>
                          {item.in_time ?? ""}
                        </div>
                      </div>
                      <div>
                        <div
                          style={{
                            fontSize: `${fontResize(11, fontPercentage)}px`,
                            color: "#707D88",
                            fontWeight: "600",
                          }}
                        >
                          Dock Number
                        </div>
                        <div
                          style={{
                            display: "flex",
                            fontSize: `${fontResize(13, fontPercentage)}px`,
                            alignItems: "center",
                            justifyContent: "center",
                            fontWeight: "600",
                            color: "#0D283E",
                            height: "100%",
                            minHeight: "20px",
                          }}
                        >
                          {item.display_name ?? ""}
                        </div>
                      </div>
                      <div>
                        <div
                          style={{
                            fontSize: `${fontResize(11, fontPercentage)}px`,
                            color: "#707D88",
                            fontWeight: "600",
                          }}
                        >
                          Timer
                        </div>
                        <div
                          style={{
                            display: "flex",
                            fontSize: `${fontResize(13, fontPercentage)}px`,
                            alignItems: "center",
                            justifyContent: "center",
                            fontWeight: "600",
                            color: "#0D283E",
                            height: "100%",
                            minHeight: "20px",
                          }}
                        >
                          {/* {item.duration ?? ''}
                           */}
                          <LiveTimer
                            initialTime={item.duration ?? ""}
                            status={item.current_status}
                            fontPercentage={fontPercentage}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style={progressBar(
                    item.current_status === "overdelay"
                      ? "#FF3B5F"
                      : item.current_status === "ontime"
                      ? "#40F7BE"
                      : "#FFC01B"
                  )}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };
  const fontResize = (baseFont, percentage) => {
    const fontSize = baseFont * (1 + percentage / 100);
    return fontSize;
  };

  const customFontPercentage = (width, width_size) => {
    if (width === "custom") return width_size ?? 0;
    if (width === "large") return 30;
    if (width === "medium") return 0;
    if (width === "small") return -20;
    return 0;
  };

  const widgetRenderers = {
    Timings: timingWidget,
    "Average duration": averageDurationWidget,
    "Live monitor": liveMonitorWidget,
  };

  const apiMap = {
    "Live count": getCountDetails,
    "History count": getHistoryCount,
    "Average duration": fetchAverageData,
    Timings: getTimingsDetails,
    "Location based dock in and out": getlocationinoutDetails,
    "Live monitor": getLiveMonitorDetails,
    "Dock status": fetchDockStatusData,
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#FFFFFF",
        width: "100%",
        height: "100%",
      }}
    >
      <div
        style={{
          color: "#0D283E",
          fontWeight: "700",
          fontSize: "16px",
          padding: "8px",
          paddingLeft: "20px",
          flex: "0 0 auto",
          borderBottom: "1px solid #D5DDE7",
        }}
      >
        Dock overview dashboard
      </div>

      <div style={{ flex: "1 1 0", maxHeight: "100%" }}>
        <Row
          className="g-0 text-center pb-2"
          style={{ borderBottom: "1px solid #D5DDE7" }}
        >
          {liveCountWidget(20)}

          {historyCountWidget(30)}
        </Row>
        <Row>
          {/* LEFT COLUMN */}
          {locationBasedDockWidget(50)}

          {/* CENTER COLUMN */}
          <Col style={{ flex: "1 1 0", minWidth: 0, padding: 0, margin: 0 }}>
            <div
              className="px-2"
              style={{
                backgroundColor: "#EDF0F4",
                height: "fit-content",
                paddingBottom: "20px",
              }}
            >
              {sortedWidgetList?.map((widget, i) => {
                if (!widget.status) return null;
                const fontPercentage = customFontPercentage(
                  widget.width,
                  widget.width_size
                );
                const renderer = widgetRenderers[widget.name];
                return renderer ? renderer(fontPercentage) : null;
              })}
            </div>
          </Col>

          {/* RIGHT COLUMN */}
          {dockStatusWidget()}
        </Row>
      </div>
    </div>
  );
}

/* <ListGroup.Item key={`dup-free-${idx}`} className="d-flex justify-content-between align-items-center px-0 py-2 " style={{ borderBottom: '1px solid #dee2e6' }}>
                                            <div className="d-flex align-items-center gap-2">
                                                <img src={Map} alt="location" style={{ width: '16px', height: '16px', display: 'inline-block', verticalAlign: 'middle', objectFit: 'contain' }} />
                                                <span
                                                    style={{
                                                        fontSize: '15px',
                                                        color: '#0f172a',
                                                        maxWidth: '140px', // or adjust based on layout
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                        display: 'inline-block',
                                                        verticalAlign: 'middle',
                                                    }}
                                                    title={loc.location}
                                                >
                                                    {loc.location}
                                                </span>

                                            </div>
                                            <span style={{ fontSize: '15px', color: '#0f172a', fontWeight: 500 }}>{loc.count}</span>
                                        </ListGroup.Item> */
